<div class="feature-flags">
  <app-title-bar
    title="Feature Flags"
    description="Global switch and company default for each feature. Changes can take up to 30 seconds to apply."
  ></app-title-bar>

  <div class="feature-flags-state" *ngIf="loading">Loading feature flags…</div>
  <div class="feature-flags-state feature-flags-state--error" *ngIf="!loading && errorMessage">
    {{ errorMessage }}
    <button type="button" class="btn btn-outlined btn-small" (click)="load()">Retry</button>
  </div>
  <div class="feature-flags-state" *ngIf="!loading && !errorMessage && flags.length === 0">
    No feature flags found.
  </div>

  <div class="feature-flags-table-wrap" *ngIf="!loading && !errorMessage && flags.length > 0">
    <table class="feature-flags-table">
      <thead>
        <tr>
          <th>Flag</th>
          <th>Description</th>
          <th>Global</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let flag of flags; trackBy: trackFlag">
          <td>
            <code>{{ flag.key }}</code>
          </td>
          <td>
            <p class="feature-flags-description" *ngFor="let line of linesOf(flag.description)">
              {{ line }}
            </p>
          </td>
          <td>
            <mat-slide-toggle
              [checked]="flag.global_enabled"
              [disabled]="saving"
              (change)="onToggleChange($event, flag)"
              [attr.aria-label]="'Global switch for ' + flag.key"
            ></mat-slide-toggle>
            <span class="feature-flags-muted">{{ onOffLabel(flag.global_enabled) }}</span>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>

<app-confirm-action-modal
  testId="feature-flag-dialog"
  *ngIf="pending"
  [title]="dialogTitle"
  [confirmLabel]="pending.turnOn ? 'Turn on' : 'Turn off'"
  [busy]="saving"
  [mobileSheet]="false"
  (confirm)="confirmDialog()"
  (cancel)="cancelDialog()"
>
  <ng-container *ngIf="pending.turnOn; else turnOff">
    <fieldset class="feature-flags-choices">
      <label class="feature-flags-choice">
        <input
          type="radio"
          name="global-on-choice"
          value="all"
          [checked]="choice === 'all'"
          (change)="setChoice('all')"
        />
        <span>On for all companies and locations (clears existing offs)</span>
      </label>
      <label class="feature-flags-choice">
        <input
          type="radio"
          name="global-on-choice"
          value="opt-in"
          [checked]="choice === 'opt-in'"
          (change)="setChoice('opt-in')"
        />
        <span>Keep per-company off (opt in each company)</span>
      </label>
    </fieldset>
  </ng-container>
  <ng-template #turnOff>
    <p class="feature-flags-dialog-text">{{ offMessage }}</p>
  </ng-template>
  <p class="feature-flags-dialog-text">{{ propagationNote }}</p>
</app-confirm-action-modal>
